<template>
  <tr>
    <td v-if="dynamic" class="pl-0" nowrap>
      <span v-if="!editing">
        <button
          v-if="!deleting"
          @click.prevent="deleting = true"
          class="btn btn-link p-0 pr-2"
        >
          <i class="fa fa-trash-alt text-danger" />
        </button>
        <span v-else>
          Are you sure?
          <button @click.prevent="$emit('destroy', index)" class="btn btn-danger">
            Yes
          </button>
          <button @click.prevent="deleting = false" class="btn btn-secondary">
            No
          </button>
        </span>
      </span>
      <span v-if="!deleting">
        <button
          v-if="!editing"
          @click.prevent="editing = true"
          class="btn btn-link p-0"
        >
          <i class="fa fa-edit text-success" />
        </button>
        <span v-else>
          <button @click="save" class="btn btn-success">
            Save
          </button>
          <button @click="editing = false" class="btn btn-secondary">
            Cancel
          </button>
        </span>
      </span>
    </td>
    <td v-for="(value, index) in row" :key="index">

      <component
        :is="value.type"
        :key="index"
        :block="value"
        :blocks="blocks"
        :definitions="definitions"
        :asset="asset"
        :show-actions="false"
        :editing="editing"
        :saveTrigger="saveTrigger"
      />

    </td>
  </tr>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractHelpers from '@/Mixins/contractHelpers';
import contractComponents from '@/Mixins/contractComponents';

export default {
  mixins: [helpers, contractHelpers, contractComponents],

  props: {
    row: {
      type: Array,
      required: true,
    },
    index: Number,
    blocks: Array,
    definitions: Array,
    showActions: Boolean,
    dynamic: Boolean,
    asset: Object,
  },

  data() {
    return {
      deleting: false,
      editing: false,
      saveTrigger: this.randomString(),
    };
  },

  methods: {
    save() {
      this.saveTrigger = this.randomString();
      this.editing = false;
    },

    randomString() {
      return Math.random().toString(36).substring(7);
    },
  },
};
</script>
